import apiClient from '@/utility/apiClient'
import { TopAllResponse } from '@/lib/api/types/api'
import { handleApiError } from '@/lib/api/utils/errorHandler'

/**
 * Home page related API calls
 */
export const HomeService = {
  /**
   * Get all top page content
   */
  getTopAll: async (): Promise<TopAllResponse> => {
    try {
      const url = 'top-all'
      const response = await apiClient.request('GET', url, {
        skipRequestCancellation: true, // Prevent cancellation during navigation
      })
      return response.data
    } catch (error) {
      handleApiError(error)
    }
  },
}
